import { render } from "./BackupSchedule.vue?vue&type=template&id=6c8ddb5b&scoped=true"
import script from "./BackupSchedule.vue?vue&type=script&lang=js"
export * from "./BackupSchedule.vue?vue&type=script&lang=js"

import "./BackupSchedule.vue?vue&type=style&index=0&id=6c8ddb5b&scoped=true&lang=less"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8ddb5b"]])

export default __exports__